import React from 'react';
import Reveal from 'react-reveal';
import { Component } from 'react';

class ImageBanner extends Component {
    render(){
        var {fileName}= this.props;
        return(
            <section>
                <div className="banner_top">
                    <div className="container">
                        <div className="row ">
                            <Reveal effect="fadeInUp" duration={1400}><img src={require ("../../img/banner/" + fileName)} alt="team"/></Reveal>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}
export default ImageBanner;